import styles from './PinChatButton.module.scss';
import { useObservable } from '@app/base';
import { Icon } from '@app/ui';
import { closeGlobalChat, GLOBAL_CHAT_OPEN_OBSERVABLE } from '@app/chat/utils';
import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function ExpandChatButton() {
  const navigate = useNavigate();
  const { t } = useTranslation(undefined, { keyPrefix: 'chats' });
  const [pinedChatId] = useObservable(GLOBAL_CHAT_OPEN_OBSERVABLE);

  const openFullChat = useCallback(() => {
    if (!pinedChatId) return;

    closeGlobalChat();
    navigate(`/chat/${pinedChatId}`);
  }, [navigate, pinedChatId]);

  return (
    <Tooltip title={t('tooltips.openFullChat')}>
      <Button
        className={classNames(styles.button, styles.pined)}
        type="link"
        icon={<Icon type="open" />}
        aria-label={t('tooltips.openFullChat')}
        onClick={openFullChat}
      />
    </Tooltip>
  );
}
